import type {
	WalletResponse,
	FundWalletParameters,
	IRequestResponse,
	WithDrawalParameters,
	WithDrawalResponse
} from '@/types'

export default function useWalletApi() {
	const fetchWalletDetails = async (cacheTime = 200, query?: Record<string, unknown>) => {
		const { data, error } = await useAPI<IRequestResponse<WalletResponse>>('wallet', {
			query
		})
		if (!error.value) {
			const { setWalletDetails } = useUser()
			setWalletDetails(data.value?.data)
		}
		return data
	}

	const WithDrawFund = async (payload: WithDrawalParameters) => {
		return await useAPI<IRequestResponse<WithDrawalResponse>>('/wallet/withdraw', {
			method: 'POST',
			body: payload
		})
	}
	const FinalizeWithdraw = async (payload: WithDrawalResponse) => {
		return await useAPI<IRequestResponse>('/wallet/finalize-withdraw', {
			method: 'POST',
			body: payload
		})
	}

	const FundWallet = async (payload: FundWalletParameters) => {
		return await useAPI<IRequestResponse<WalletResponse>>('/wallet/fund', {
			method: 'POST',
			body: payload
		})
	}

	async function GetBanks() {
		return await useAPI<IRequestResponse<BankBranchContext>>('/resources/banks')
	}

	async function GetBankInformation(payload: BankInformationParameter) {
		return await useAPI<IRequestResponse<BankInformationContext>>('/resources/banks/resolve', {
			body: payload,
			method: 'POST'
		})
	}

	return {
		fetchWalletDetails,
		WithDrawFund,
		FinalizeWithdraw,
		FundWallet,
		GetBanks,
		GetBankInformation
	}
}
